import controller from './profile.controller';
import template from './profile.html';

const profileComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default profileComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/profile/profile.component.js
 **/